import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import { ErrorFallback } from 'components/ErrorFallback';
import { useSciDomain } from 'components/SciDomainContext';
import { PageLayoutViewProps } from 'types';

export const RosaOnePageLayoutView = ({ handleError }: PageLayoutViewProps) => {
  const { data: { title } = {}, isLoading, isError } = useSciDomain();

  if (isLoading && !isError) {
    return null;
  }

  return (
    <div
      style={{
        colorScheme: 'dark',
        background: '#07131f',
        color: '#f5fbff',
        fontFamily:
          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        minHeight: '100vh',
        WebkitFontSmoothing: 'antialiased',
      }}
    >
      <title>{title}</title>
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
        <Outlet />
      </ErrorBoundary>
    </div>
  );
};
